
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'7-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            푸터 관리 - 협력업체 {{ $route.query.partner_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.partner_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='partner_name'>협력업체명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'partner_name'
                maxLength="50"
                placeholder = "협력업체명을 입력해 주세요.(50자 이내)"
                v-model="formData.partnerName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.partnerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='partner_link'>링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'partner_link'
                maxLength="200"
                placeholder = "링크를 입력해 주세요."
                v-model="formData.partnerLink"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.partnerLinkError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='partner_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="partner_status"
                v-model="formData.partnerStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">노출 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 220 x 55px</p>
                <label for='partner_image' class="Admin_imgBanner_Btn">
                  {{ $route.query.partner_ID === undefined ? '추가' : '변경' }}
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'partner_image'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_PartnerBanner">
                  <img
                    :src="formData.partnerImageUrl === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.partnerImageUrl"
                    alt="이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.partnerImageUrlError}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_partner_one,
  insert_partner,
  update_partner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminPartnerManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        partnerName: '',
        partnerLink: '',
        partnerStatus: 1,
        partnerImage: '',
        partnerImageUrl: ''
      }),
      errorData: ref({
        partnerNameError: '',
        partnerLinkError: '',
        partnerImageUrlError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.partnerImage = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.partnerImageUrl = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.partnerName === '') {
        this.errorData.partnerNameError = '협력업체명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.partnerNameError = ''
      }
      if (this.formData.partnerLink === '') {
        this.errorData.partnerLinkError = '링크를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.partnerLinkError = ''
      }
      if (this.formData.partnerImageUrl === '') {
        this.errorData.partnerImageUrlError = '노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.partnerImageUrlError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.partner_ID === undefined) {
          insert_partner(
            this.formData.partnerName,
            this.formData.partnerImage,
            this.formData.partnerLink,
            this.formData.partnerStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminPartnerManagement'
          })
        } else {
          update_partner(
            this.$route.query.partner_ID,
            this.formData.partnerName,
            this.formData.partnerImage,
            this.formData.partnerLink,
            this.formData.partnerStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminPartnerManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.partner_ID !== undefined) {
      get_partner_one(this.$route.query.partner_ID).then((result) => {
        this.formData.partnerName = result[0].partner_name
        this.formData.partnerLink = result[0].partner_link
        this.formData.partnerStatus = result[0].partner_status
        this.formData.partnerImageUrl = result[0].partner_image
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/FooterManagement/AdminPartnerManagementAdd.vue